import React, { useEffect, useState, useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import axios from 'axios';
import DataTable from "react-data-table-component";
import { env } from './const';
import { headers } from '../utils/common';
import { getRole } from '../utils/common';
import { Role } from '../utils/role';
import DeactivateFarm from './DeactivateFarm';
import { Modal, Button } from 'react-bootstrap';
import { getUserName } from '../utils/common';
import { useLoading, Bars } from '@agney/react-loading';
import * as axiosInstance from '../utils/axiosinstace';
import GrowthCurveComponent from "./GrowthCurveComponent";
import { AiFillFilePdf } from "react-icons/ai";
import moment from "moment";
import $ from 'jquery';
import 'select2';
import { useTranslation } from 'react-i18next';

const DailyOperationsReport = () => {
  const { t } = useTranslation(['batch', 'common']);
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
    });
    const { containerProps: containerProps2, indicatorEl: indicatorEl2 } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
    });
    const [role] = useState(getRole());
    const [farmData, setFarmData] = useState([]);
    const [batchData, setBatchData] = useState([]);
    const [headersobj] = useState(headers());
    const [graphData, setGraphData] = useState({});
    const [showGraph, setShowGraph] = useState(false);
    const [showLoader, setShowloader] = useState(false);
    const [showLoader2, setShowloader2] = useState(false);

    const { register, handleSubmit, watch, formState: { errors }, setValue, trigger } = useForm({
        mode: 'onChange'
    });
    const onchangeHandler = async (e) => {

        try {
            setShowData(true);
            const response = await axiosInstance.getListofBatches(e.target.value, 'full');
            setBatchData(response.list);
            setShowGraph(false);
        } catch (err) {
            setBatchData([]);
            console.log(err);
        }
    }
    const [xaxis, setXaxis] = useState([]);
    const [yaxis, setYaxis] = useState([]);
    const [idleweights, seIdleweights] = useState([]);
    const [showData, setShowData] = useState(true);
    const [maleSeries, setMaleSeries] = useState([]);
    const [femaleSeries, setFemaleSeries] = useState([]);
    const [asHatchedSeries, setAsHatchedSeries] = useState([]);
    const [sexingStatus, setSexingStatus] = useState('no');
    const [data, setData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [maleLegends, setMaleLegends] = useState([]);
    const [femaleLegends, setFemaleLegends] = useState([]);
    const [chickLegends, setChickLegends] = useState([]);
    const [otherInfo, setOtherInfo] = useState({
        breedName: "",
        batchDuration: "",
        startDate: "",
        endDate: "",
        sexing: "",
        status: "",
        farmer: "",
        farm: "",
        batchName: "",
        company: "",
        numberofBirds: ""
    })
    const [resonseData, setResponseDate] = useState('');
    const onSubmit = async (data, e) => {
        e.preventDefault();
        setShowloader(true);
        try {
            const response = await axiosInstance.getGrowthCurve(data.batchID);

            if (response.status == false) {
                alert('Hi')
                setShowData(false);
                setShowloader(false);
                setErrorMessage(response.message)
                return;
            }

            if (response.data.length == 0) {
                setShowData(false);
                setShowloader(false);
                setErrorMessage(response.message);
                return;
            }
            setShowData(false);
            setResponseDate(response)
            setData(response.data);
            setOtherInfo(response.others)
            const days = response.data.map((item) => item.day);
            setXaxis(days);
            setSexingStatus(response.others.sexing);
            let _data = response.data;
            //alert( moment(response.others.endDate).diff(moment(), 'days'))
            const daydiff = moment(response.others.endDate).diff(moment(), 'days');
            //alert(daydiff)
            if (daydiff > 0 && response.others.status == 'ACTIVE') {
                const day = response.others.batchDuration - daydiff;
                _data = _data.filter((item) => parseInt(item.day) <= day);
                //alert(JSON.stringify(_data));
            }
            setShowloader(false);
        } catch (err) {
            setShowData(false);
            setShowloader(false);
        }


    }
    const onBatchChange = (e) => {
        setShowGraph(false);
    }
    const getFarms = async () => {
        try {
            const response = await axiosInstance.getListofFarms(getUserName());
            setFarmData(response.list)
        } catch (err) {
            console.log(err.message);

        }
    }
    const downloadReport = async () => {

        setShowloader2(true);
        try {
            console.log(otherInfo)
            const response = await axiosInstance.downloadDopReport(resonseData)
            const url = window.URL.createObjectURL(new Blob([response]));
            // Create a link element to download the blob
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'dopreport.pdf'); // Set the filename for the download
            document.body.appendChild(link); // Append to the body
            link.click(); // Trigger the download
            document.body.removeChild(link); // Clean up
            setShowloader2(false);
        } catch (err) {
            console.log(err);
            setShowloader2(false);
            alert(t('batch:report.downloadError'))
        }
    }
    const [selectedFarmer, setSelectedFarmer] = useState("");
    const getFarms_admin = async (farmerID) => {
        try {
            const response = await axiosInstance.getListofFarms_active_admin(farmerID);
            setFarmData(response.list);
          
        } catch (err) {
            console.log(err.message);
        }
    }
    const [farmers, setFarmers] = useState([]);
    const getFarmers = async () => {
        try {
            const response = await axiosInstance.getListofFarmers_admin();
            setFarmers(response.list);
        } catch (err) {
            console.log(err.message);
        }
    }
    useEffect(() => {
        if (role === Role.Admin) {
            getFarmers();
        } else {
            getFarms()
        }
       
    }, []);

    useEffect(() => {
        const farmerSelect = $("#selectFarmer").select2();
        farmerSelect.on("change", function (e) {
          const selectedFarmerID = e.target.value;
          setSelectedFarmer(selectedFarmerID);
          setBatchData([]);
          setShowData (true);
          setShowGraph(false);
          if (role === Role.Admin) {
            getFarms_admin(selectedFarmerID)
          }
        });
      
        const farmSelect = $("#selectFarm").select2();
        farmSelect.on("change", function (e) {
          trigger("famrmID"); // Manually trigger validation for 'selectFarm'
          setValue("famrmID", e.target.value, { shouldValidate: true });
          onchangeHandler(e);
        });
      
        return () => {
          farmerSelect.off("change");
          farmerSelect.select2("destroy");
          farmSelect.off("change");
          farmSelect.select2("destroy");
        };
      }, [farmData]);
    return (

        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('batch:report.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <div className="row">
                        {
                                role == Role.Admin ?
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>{t('common:select.farmer')}</label>
                                            <select
                                                style={{ width: "100%" }} id="selectFarmer"
                                                className="form-control form-control-sm">
                                                <option value="">{t('common:select.dashed')}</option>
                                                {farmers.map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.farmerName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    : <></>}
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>{t('common:select.barn')}</label>
                                    <select class="form-control" name="famrmID" id="selectFarm"
                                        {...register("famrmID", { required: true })}
                                    //onChange={onchangeHandler}
                                    >
                                        <option value="">{t('common:select.dashed')}</option>
                                        {farmData.map(item => (
                                            <option
                                                key={item.farmID}
                                                value={item.farmID}
                                            >
                                                {item.farmName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.famrmID && <span className="err-msg">{t('common:validation.selectBarn')}</span>}
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>{t('common:select.batch')}</label>
                                    <select class="form-control" name="batchID" onChange={onBatchChange}
                                        {...register("batchID", { required: true })}
                                    >
                                        <option value="">{t('common:select.dashed')}</option>
                                        {batchData.map(item => (
                                            <option
                                                key={item.batchID}
                                                value={item.batchID}
                                            >
                                                {item.batchName}

                                            </option>
                                        ))}
                                    </select>
                                    {errors.batchID && <span className="err-msg">{t('common:validation.selectBatch')}</span>}
                                </div>
                            </div>
                            <div className="col-md-1 form-group">
                                <div class="spacer"></div>
                                <input type="submit" value="Fetch" class="btn btn-primary" />
                            </div>
                            <div className='col-md-1'>
                                {showLoader ?
                                    <section {...containerProps} style={{ "margin-top": "30px" }}>
                                        {indicatorEl}
                                    </section> : ""
                                }
                            </div>
                            <div className="col-md-2">
                                {showData ?
                                    <></>
                                    :
                                    <div className="downloadLink">
                                        <>
                                            {showLoader2 ?
                                                <section {...containerProps} style={{ "margin-top": "30px" }}>
                                                    {indicatorEl}
                                                </section> : <>
                                                    <span style={{ cursor: "pointer" }}
                                                    ><AiFillFilePdf size={28} color="red"></AiFillFilePdf></span> <span onClick={() => { downloadReport() }}>{t('batch:report.downloadPdf')}</span>
                                                </>
                                            }
                                        </>

                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                    {
                        showData ?
                            <div className="row">
                                <div className="col-md-12">
                                    <p className="redColor">{errorMessage}</p>
                                </div>
                            </div>
                            :
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <table className="table table-striped table-sm">
                                            <tbody>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:entity.farmer')}</td>
                                                    <td>{otherInfo.farmer}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('batch:report.company')}</td>
                                                    <td>{otherInfo.company == null || otherInfo.company == '' ? '--' : otherInfo.company}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:entity.barn')}</td>
                                                    <td>{otherInfo.farm}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:fields.startDate')}</td>
                                                    <td>{otherInfo.startDate}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:metrics.sexing')}</td>
                                                    <td>{otherInfo.sexing.toLocaleUpperCase()}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <table className="table table-striped table-sm">
                                            <tbody>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:entity.integrator')}</td>
                                                    <td>{otherInfo.integrator}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader"># of Birds</td>
                                                    <td>{otherInfo.numberofBirds}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:entity.batch')}</td>
                                                    <td>{otherInfo.batchName}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:fields.closeDate')}</td>
                                                    <td>{otherInfo.endDate}</td>
                                                </tr>
                                                <tr>
                                                    <td class="summaryHeader">{t('common:fields.type')}</td>
                                                    <td>{otherInfo.breedName}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {
                                    sexingStatus == 'no' ?

                                        <div className="row">
                                            <div className="col-md-12">
                                                <table class="dailyOperationsTable table table-striped table-sm table-bordered">
                                                    <tr>
                                                        <th rowspan="2">{t('common:time.day')}</th>
                                                        <th rowspan="2">{t('common:fields.date')}</th>
                                                        <th rowspan="2">{t('batch:report.feedKg')} <br /> {t('batch:report.totalConst')}</th>
                                                        <th colspan="3">{t('batch:report.mortalityTotal')} {otherInfo.all_mortality})</th>
                                                        {/* <th rowspan="2">{t('batch:report.recordedWeightKg')}</th>
                                                        <th rowspan="2">{t('batch:report.idealWeightKg')}</th>
                                                        <th rowspan="2">{t('batch:report.varianceActualVsIdeal')}</th> */}
                                                        <th colspan="3">{t('batch:report.recordedWeightMaleKg')}</th>
                                                        <th rowspan="2">{t('common:metrics.fcr')}</th>
                                                    </tr>
                                                    <tr>
                                                        <th class="">{t('common:metrics.natural')}</th>
                                                        <th>{t('common:metrics.culling')}</th>
                                                        <th>{t('common:metrics.total')}</th>
                                                        <th>{t('batch:report.actual')}</th>
                                                        <th>{t('batch:report.ideal')}</th>
                                                        <th>{t('batch:report.variance')}</th>
                                                    </tr>
                                                    {data.map(item => (
                                                        <tr>
                                                            <td>{item.day}</td>
                                                            <td>{item.date}</td>
                                                            <td>{item.feed}</td>
                                                            <td>{item.mortality}</td>
                                                            <td>{item.culling}</td>
                                                            <td>{item.total}</td>
                                                            <td>{item.chickweight}</td>
                                                            <td>{item.ideal}</td>
                                                            <td>{item.variance}</td>
                                                            <td>{isNaN(item.fcr)? '--': item.fcr}</td>
                                                        </tr>
                                                    ))}
                                                </table>
                                            </div>
                                        </div>
                                        :
                                        <div className="row">
                                            <div className="col-md-12">
                                                <table class="dailyOperationsTable table table-striped table-sm table-bordered">
                                                    <tr>
                                                        <th rowspan="2">{t('common:time.day')}</th>
                                                        <th rowspan="2">{t('common:fields.date')}</th>
                                                        <th rowspan="2">{t('batch:report.feedKg')} <br /> {t('batch:report.totalConst')}</th>
                                                        <th colspan="6">{t('batch:report.mortalityTotal')} {otherInfo.all_mortality_sexing})</th>
                                                        <th colspan="3">{t('batch:report.recordedWeightMaleKg')}</th>
                                                        <th colspan="3">{t('batch:report.recordedWeightFemaleKg')}</th>
                                                        <th colspan="2">{t('common:metrics.fcr')}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>{t('batch:report.naturalMale')}</th>
                                                        <th>{t('batch:report.cullingMale')}</th>
                                                        <th>{t('batch:report.totalMale')}</th>
                                                        <th>{t('batch:report.naturalFemale')}</th>
                                                        <th>{t('batch:report.cullingFemale')}</th>
                                                        <th>{t('batch:report.totalFemale')}</th>
                                                        
                                                        <th>{t('batch:report.actual')}</th>
                                                        <th>{t('batch:report.ideal')}</th>
                                                        <th>{t('batch:report.variance')}</th>
                                                        
                                                        <th>{t('batch:report.actual')}</th>
                                                        <th>{t('batch:report.ideal')}</th>
                                                       
                                                        <th>{t('batch:report.variance')}</th>
                                                        <th>{t('common:gender.male')}</th>
                                                        <th>{t('common:gender.female')}</th>
                                                    </tr>

                                                    {data.map(item => (
                                                        <tr>
                                                            <td>{item.day}</td>
                                                            <td>{item.date}</td>
                                                            <td>{item.feed}</td>
                                                            <td>{item.natural_male}</td>
                                                            <td>{item.culling_male}</td>
                                                            <td>{item.total_male}</td>
                                                            <td>{item.natural_female}</td>
                                                            <td>{item.culling_female}</td>
                                                            <td>{item.total_female}</td>
                                                            <td>{item.chickweight_male }</td>
                                                            <td>{item.ideal_male }</td>
                                                            <td
                                                                style={{background: 
                                                                    item.variance_male=='--'? '#888':
                                                                    item.variance_male >= item.ideal_male? '#216e00':
                                                                    item.variance_male <=0 ? '#a30202':
                                                                    (item.variance_male <item.chickweight_male && item.variance_male>0)? '#f29202'
                                                                    :'#888',
                                                                color: '#fff'}}
                                                            >{item.variance_male }</td>
                                                            <td>{item.chickweight_female }</td>
                                                            <td>{item.ideal_female }</td>
                                                            <td
                                                                style={{background: 
                                                                    item.variance_female=='--'? '#888':
                                                                    item.variance_female >= item.ideal_female? '#216e00':
                                                                    item.variance_female <=0 ? '#a30202':
                                                                    (item.variance_female <item.chickweight_female && item.variance_female>0)? '#f29202'
                                                                    :'#888',
                                                                color: '#fff'}}
                                                            >{item.variance_male }</td>
                                                            
                                                            <td>{isNaN(item.fcr_male)? '--': item.fcr_male}</td>
                                                            <td>{isNaN(item.fcr_female)?'--':item.fcr_female}</td>
                                                           
                                                        </tr>
                                                    ))}
                                                </table>


                                            </div>
                                        </div>
                                }
                            </div>

                    }
                </div>
            </div>
        </div>

    );
}

export default DailyOperationsReport;